<template lang="pug">
	.creative-settings-actions-delete(v-if="showed && version")
		.card
			.card-header
				i.fa.fa-edit
				span Delete creative version
			.card-body.collapse.show
				.form-horizontal
					.form-group
						label.col-form-label Are you sure you want to delete "{{version.title || version.codename}}" version?
					.form-actions
						button.btn.btn-danger(type="submit" v-on:click="deleteVersion()")
							i.fa.fa-remove
							span Delete version
						button.btn.btn-ghost-dark(type="button" v-on:click="cancel()") Cancel
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Creative } 			from './../../services/Creative'
	import { Version } 			from './../../services/Version'
	import { Settings } 		from './../../services/Settings'

	export default {
		name: "VersionDelete",
		mixins: [Screen],
		screen: {
			updateOn: []
		},
		data() {

			this.Creative = Creative;
			this.Settings = Settings;

			this.version = null;

			return {

			};

		},
		methods: {
			collectData(event, versionId) {

				this.version = Version.getVersion(versionId);
				if (!this.version) return;

			},
			deleteVersion() {

				Server.sendToSocket({
					DeleteVersion: {
						versionId: this.version.id
					}
				});

				Broadcast.call("Current Version Deleting");

				this.hide();

			},
			cancel() {

				Broadcast.call("Show VersionSettings", [this.version.id]);

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.creative-settings-actions-delete
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 180px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.btn-ghost-dark
				float: right
				color: #fff

			.btn-danger

				i
					margin-right: 10px

</style>

